import React,{useEffect,useRef}from "react";
import { Box,Container,Typography } from "@mui/material";
import BenefitsFeature from "./benefitFeatures.js";
import "./benefits.css";
import decentralizedImage from "../../../../static/Images/benefits/decenterlized.png";
import fairImage from "../../../../static/Images/benefits/fair.png";
import globalImage from "../../../../static/Images/benefits/global-access.png";
import payoutsImage from "../../../../static/Images/benefits/instant-payouts.png";
import gamesImage from "../../../../static/Images/benefits/wide-game-selection.png";
import communityImage from "../../../../static/Images/benefits/community-driven.png";
import benefitsBackground from "../../../../static/Images/benefits/benefits_background.png";
import {
 setupBackgroundAnimation,
 setupEntranceAnimation,
 setupPinnedAnimation
} from "../animations";
import gsap from "gsap";

const benefitsFeatures=[
 {title:"Decentralized",mainDescription:"A truly player-owned platform powered by blockchain, giving you freedom, transparency, and full control.",description:"Built on blockchain with smart contracts.",image:decentralizedImage},
 {title:"Provably Fair",mainDescription:"Every game is powered by transparent technology, allowing players to verify results and trust the outcome.",description:"Every result is verifiable on-chain.",image:fairImage},
 {title:"Global Access",mainDescription:"Play from anywhere in the world, connecting players across the globe through a truly accessible gaming platform.",description:"Play from anywhere in the world.",image:globalImage},
 {title:"Instant Payouts",mainDescription:"Get your winnings directly in your wallet without unnecessary delays, keeping every payout fast and transparent.",description:"Winnings are sent directly to your wallet.",image:payoutsImage},
 {title:"Wide Game Selection",mainDescription:"Explore a growing collection of lotteries, slots, originals, and more, all available within one platform.",description:"Lotteries, slots, originals and more.",image:gamesImage},
 {title:"Community Driven",mainDescription:"Built around the players, AutoBET grows with its community and creates a gaming experience shaped by the people who use it.",description:"Built by players, for players.",image:communityImage}
];

const Benefits=()=>{
 const sectionRef=useRef(null);
 const kickerRef=useRef(null);
 const titleRef=useRef(null);
 const descriptionRef=useRef(null);

 useEffect(()=>{
  const ctx=gsap.context(()=>{
   setupBackgroundAnimation(sectionRef);
   setupEntranceAnimation(sectionRef,kickerRef,titleRef,descriptionRef);
   setupPinnedAnimation(sectionRef,kickerRef,titleRef,descriptionRef);
  },sectionRef);

  return()=>ctx.revert();
 },[]);

 return(
  <Box id="benefits" component="section" className="home-benefits" ref={sectionRef} sx={{
   bgcolor:"custom.colors.home.cardFlat",
   minHeight:"100vh"
  }}>
   {/* Background Chipped Reveal Grid */}
   <Box
    className="benefits-hover-background"
    sx={{
     position:"absolute",
     inset:0,
     width:"100%",
     height:"100%",
     zIndex:0,
     pointerEvents:"none",
     display:"grid",
     gridTemplateColumns:{xs:"repeat(6,1fr)",md:"repeat(8,1fr)",lg:"repeat(10,1fr)"},
     gridTemplateRows:"repeat(6,1fr)",
     overflow:"hidden",
    }}
   >
    {Array.from({length:60}).map((_,index)=>{
     const columns=10;
     const column=index%columns;
     const row=Math.floor(index/columns);

     return(
      <Box
       key={index}
       className="benefits-bg-tile"
       sx={{
        width:"100%",
        height:"100%",
        minWidth:0,
        minHeight:0,
        opacity:0,
        position:"relative",
        overflow:"hidden",
        "--col":column,
        "--row":row,
        "--cols":columns,
        "--rows":6,
       }}
      >
       <Box
        className="benefits-bg-tile-inner"
        sx={{
         position:"absolute",
         width:"calc(100% * var(--cols))",
         height:"calc(100% * var(--rows))",
         left:"calc(var(--col) * -100%)",
         top:"calc(var(--row) * -100%)",
         backgroundImage:`url(${benefitsBackground})`,
         backgroundSize:"cover",
         backgroundPosition:"center",
         backgroundRepeat:"no-repeat",
         pointerEvents:"none",
        }}
       />
      </Box>
     );
    })}
   </Box>

   <Container className="benefits-container" sx={{px:0,maxWidth:"none"}}>
    <Box className="benefits-intro" sx={{pt:{xs:"40px",md:"50px",lg:"64px"}}}>
     <Typography ref={kickerRef} className="benefits-kicker" sx={{
      color:"custom.colors.home.brandRed",
      fontSize:{xs:"11px",lg:"12px"},
      fontWeight:700,
      letterSpacing:"0.18em",
      mb:"14px"
     }}>
      BUILT BY PLAYERS. POWERED BY BLOCKCHAIN.
     </Typography>

     <Typography ref={titleRef} className="benefits-title" sx={{
      color:"custom.colors.home.brandDark",
      fontSize:{xs:"42px",md:"52px",lg:"64px"},
      fontWeight:800,
      lineHeight:1.05,
      m:0,
      display:"inline-block"
     }}>
      Why AutoBET?
     </Typography>

     <Typography ref={descriptionRef} className="benefits-description" sx={{
      color:"custom.colors.home.grayBlue",
      fontSize:{xs:"15px",lg:"17px"},
      lineHeight:1.5,
      maxWidth:"620px",
      m:"20px auto 0"
     }}>
      Explore the features that make AutoBET transparent, accessible, and built for a global community of players.
     </Typography>
    </Box>

    <Box className="benefits-cards-wrapper">
     <Box className="benefits-cards">
      {benefitsFeatures.map((feature,index)=>(
       <BenefitsFeature
        key={feature.title}
        number={index+1}
        title={feature.title}
        mainDescription={feature.mainDescription}
        description={feature.description}
        image={feature.image}
       />
      ))}
     </Box>
    </Box>
   </Container>
  </Box>
 );
};

export default Benefits;